module.exports = __webpack_public_path__ + "img/ar_light.f1ca5764.png";